import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './noBorders.css'; // Remove white borders from application
import App from './App';
import { ThemeProvider, createTheme } from '@material-ui/core/styles'; // Import for Material-UI v4

// Create a theme instance
const theme = createTheme(); // If needed, you can customize your theme here

try {
  if (typeof window !== 'undefined') {
    const patchCtx = (Ctx) => {
      if (!Ctx || !Ctx.prototype) return;
      if (typeof Ctx.prototype.getProgramInfoLog === 'function') {
        const origGetProgramInfoLog = Ctx.prototype.getProgramInfoLog;
        Ctx.prototype.getProgramInfoLog = function (...args) {
          const res = origGetProgramInfoLog.apply(this, args);
          return res == null ? '' : res;
        };
      }
      if (typeof Ctx.prototype.getShaderInfoLog === 'function') {
        const origGetShaderInfoLog = Ctx.prototype.getShaderInfoLog;
        Ctx.prototype.getShaderInfoLog = function (...args) {
          const res = origGetShaderInfoLog.apply(this, args);
          return res == null ? '' : res;
        };
      }
    };

    patchCtx(window.WebGLRenderingContext);
    patchCtx(window.WebGL2RenderingContext);
  }
} catch (e) {
}

// Assuming your HTML file has a div with an id of 'root'
const container = document.getElementById('root');

// Create a root
const root = ReactDOM.createRoot(container);

// Initial render: Render an element to the root.
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>  {/* Wrap App in ThemeProvider */}
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
